import { Component, inject, signal } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { Store } from '@ngrx/store';
import { selectBannerText } from '../../store/webshop/webshop.selectors';

@Component({
  selector: 'app-intro-dialog',
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule
  ],
  templateUrl: './intro-dialog.component.html',
  styleUrl: './intro-dialog.component.scss'
})
export class IntroDialogComponent {
  private store = inject(Store);
  visible = signal(true);
  bannerText = this.store.selectSignal(selectBannerText);
}
